import React from "react"
import PrimaryModal from "../../../../common/modals/primary-modal";
import InfoModal from "../../../../common/modals/info-modal";
import {useNavigate, useParams} from "react-router";
import ApplicationListingService from "../../../../../services/application-listing.service";

const ApplicationExit = ({completedStepperInThisSession,openModal,setOpenModal}) => {
    const {applicationId} = useParams()
    const navigate = useNavigate()

    const {useHandleExitListing} = ApplicationListingService()

    const {isLoading,mutate,isSuccess} = useHandleExitListing(applicationId,completedStepperInThisSession)

    const handleExitConfirmationModal = (isModalOpen) => {
        setOpenModal(isModalOpen)
    }

    const onExitSuccess = () => {
        navigate("/application")
    }
    return(
        <>
            {openModal &&
                <PrimaryModal
                    size={"lg"}
                    customClass={"half__modal"}
                    isOpen={openModal}
                    modalContent={
                        <InfoModal
                            handleModalClose={handleExitConfirmationModal}
                            onSuccess={onExitSuccess}
                            isLoading={isLoading}
                            mutate={mutate}
                            isSuccess={isSuccess}
                            title={"Unsaved Changes"}
                            description={"Are you sure you want to exit without saving? This action cannot be undone."}
                            confirmButtonText={"Discard"}
                        />}
                />
            }
        </>
    )
}
export default ApplicationExit
